import type { UUID } from '@cobliteam/common-types';
import type { Condition } from './conditions';

enum RuleCategory {
  // FLEET_POLICY
  GEOFENCE = 'GEOFENCE',
  IDLE_ENGINE = 'IDLE_ENGINE',
  DEVICE_CONNECTION = 'DEVICE_CONNECTION',
  VEHICLE_SPEED_LIMIT = 'VEHICLE_SPEED_LIMIT',
  ROAD_SPEED_LIMIT = 'ROAD_SPEED_LIMIT',
  DRIVER_IDENTIFICATION = 'DRIVER_IDENTIFICATION',
  CHECKLIST = 'CHECKLIST',
  CAMERAS_HEALTH = 'CAMERAS_HEALTH',

  // BACKGROUND_POLICY
  DEVICE_HEALTH_STATUS_OBSERVATION_PERIOD = 'DEVICE_HEALTH_STATUS_OBSERVATION_PERIOD',
}

enum RuleMode {
  FLEET_POLICY = 'FLEET_POLICY',
  BACKGROUND_POLICY = 'BACKGROUND_POLICY',
}

interface Rule {
  id: UUID;
  name: string;
  category: RuleCategory;
  conditions: Condition[];
  mode: RuleMode;
}

interface EventRule {
  id: UUID;
  name: string;
  nameIdentifier: string;
}

// Lista de triggers
interface TriggerRule {
  id: UUID;
  name: string;
  category: RuleCategory;
}

// Sumário
interface TriggerRuleSummary {
  id: UUID;
  name: string;
  category: RuleCategory;
  count: number;
}

export type { EventRule, Rule, TriggerRule, TriggerRuleSummary };
export { RuleCategory, RuleMode };
